import React, { useState } from 'react'
import useQuery from './utils/use-query';
import setSport,{updateDropdownStyles} from './sports';
import { set } from 'date-fns';

export default function () {
    const [ filters, setFilters, ] = useQuery(
        useState({}),
        'push',
    );
    
    
    let currentSport  = window.SPORT; 
    let facilities =  window.FACILITIES;
    if (window.newData){
        currentSport = window.newData.data.sport;
        facilities = window.newData.data.facilities;
    }

  

    const sports = window.all_sportActivities;
    const removeSports = (filters.type !== undefined)? filterSports( filters.type ) : [];

    function onSubmit (e) {
        e.preventDefault();
      
        const formData = new FormData(document.getElementById('activityForm'));
        
        const {
            'dow[]': removeDOW,
            'time[]': removeTime,
            ...filters
        } = Object.fromEntries(formData);

        const dow = Array.from(formData.getAll('dow[]'));
        const time = Array.from(formData.getAll('time[]'));
       
        return setFilters({
            ...filters,
            ...(dow.length && { dow: dow.join(',') }),
            ...(time.length && { time: time.join(',') })
        });
    }

    function onReset () {
        return setFilters({
            //type: filters.type,
            type: '',
        });
    }

    function filterSports(activity){
        const sports = window.all_sportActivities;
        let sportsResult =[];
        if (sports && sports.length>0){
            sportsResult = sports.filter(sport =>{

                const exists = sport.activities.filter(spActivity =>{
                    const count = parseInt(spActivity.count, 10);
                    return activity === spActivity.title && count>0;
                });

                return exists.length <= 0;

            })
            .map(sport => {
                    return sport.sport.sportid;
            });
        }
        return sportsResult ;
    }

    function updateSelect(activity){
        const sportsNoActivity = filterSports(activity);
        const sportOptions = document.querySelectorAll('.sport-option-js');

        sportOptions.forEach(option =>{
            option.style.display = 'block';
            if (option.hasAttribute('data-sportid')){
                const sportId = option.getAttribute('data-sportid');
                if (sportsNoActivity.includes(sportId)){
                    option.style.display = 'none';
                }
            }
        });

    }

    function onTypeSelect ({ target }) {  
        
        const value = target.dataset.value
        
        if (value && value !==''){
            let cleanState = {};
            Object.keys(filters).forEach(x => cleanState[x] = null);
            document.getElementById('activityForm').reset();
            updateSelect(value);
            return setFilters({
                ...cleanState,
                type: value,
            });        
        }
        const domain = window.location.origin;
        window.location.href = domain+"/activities/";
    }

    function showSelectOnchange(e) {
        e.preventDefault();
        const theId = e.target.dataset.theid;
        const theSelectId = e.target.dataset.theselectid;
        const theTitleId = e.target.dataset.thetitleid;
        const theTitle = e.target.dataset.thetitle;

        var select = document.getElementById(theSelectId);
        
        for(var i = 0;i < select.options.length;i++){
            if(select.options[i].value == theId ){
                select.options[i].selected = true;
            }
        }
        
        var todtitle = document.getElementById(theTitleId);
        todtitle.innerHTML = theTitle;
        todtitle.style.color = "#191818";

        if (theSelectId == "sport") {
            const domain = window.location.origin;
            const currentURL = window.location.href;
            const currentURLQuery = currentURL.split('?')[1];
            if (currentURLQuery !== undefined){    
                window.location.href = domain+"/activities/"+theId+"/?"+ currentURLQuery;
            }else{
                window.location.href = domain+"/activities/"+theId;
            }
            return
        }
        onSubmit(e);
    }

    function onSportSelect(e){
        e.preventDefault();
        updateDropdownStyles(e);

        if (e.target && e.target.dataset){
            const parent = e.target.parentNode;
            const input = parent.querySelector("input");
            input.value = e.target.dataset.id;
        }

        setSport(e, ()=>onSubmit(e));
    }

    filters && filters.type && updateSelect(filters.type);

    // handles the ligth blue hover under the "programs/camps/leagues" circle icons
    let thewidth = "";
    let themargin = "";
    let thebgcolor = "#F7F7F7";
    let screenwidth = window.innerWidth;
    if (screenwidth > 800) {
        thewidth = "69.719px";
        themargin = "0 calc(50% - 35px)";
        if (filters.type === 'programs') {
            thewidth = "89.719px";
            themargin = "0 calc(50% - 366px)";
            thebgcolor = "#38D1FF";
        } else if (filters.type === 'camp') {
            thewidth = "54.719px";
            themargin = "0 calc(50% - 185px)";
            thebgcolor = "#38D1FF";
        } else if (filters.type === 'leagues') {
            thewidth = "69.719px";
            themargin = "0 calc(50% - 35px)";
            thebgcolor = "#38D1FF";
        } else if (filters.type === 'dropins') {
            thewidth = "76.719px";
            themargin = "0 calc(50% + 122px)";
            thebgcolor = "#38D1FF";
        } else if (filters.type === 'tournaments') {
            thewidth = "113.719px";
            themargin = "0 calc(50% + 270px)";
            thebgcolor = "#38D1FF";
        }         
    } else {
        thewidth = "40px";
        themargin = "0 calc(50% - 19px) ";
        if (filters.type === 'programs') {
            thewidth = "52px";
            themargin = "0 calc(50% - 174px)";
            thebgcolor = "#38D1FF";
        } else if (filters.type === 'camp') {
            thewidth = "35px";
            themargin = "0 calc(50% - 91px) ";
            thebgcolor = "#38D1FF";
        } else if (filters.type === 'leagues') {
            thewidth = "40px";
            themargin = "0 calc(50% - 19px) ";
            thebgcolor = "#38D1FF";
        } else if (filters.type === 'dropins') {
            thewidth = "45px";
            themargin = "0 calc(50% + 52px)";
            thebgcolor = "#38D1FF";
        } else if (filters.type === 'tournaments') {
            thewidth = "48px";
            themargin = "0 calc(50% + 126px)";
            thebgcolor = "#38D1FF";
        }   
    }

    let typestr = "Activity Type";
    if (filters.type === 'programs') {
        typestr = "Programs";
    } else if (filters.type === 'camp') {
        typestr = "Camps";
    } else if (filters.type === 'leagues') {
        typestr = "Leagues";
    } else if (filters.type === 'dropins') {
        typestr = "Drop-Ins";
    } else if (filters.type === 'tournaments') {
        typestr = "Tournaments";
    }   

    let agestr = "Age Group";
    if (filters.ageRange === '24') {
        agestr = "Youth";
    } else if (filters.ageRange === '25') {
        agestr = "Adult";
    }   

    let skillstr = "Skill Level";
    if (filters.skillLevel === '9') {
        skillstr = "Beginner";
    } else if (filters.skillLevel === '10') {
        skillstr = "Intermediate";
    } else if (filters.skillLevel === '11') {
        skillstr = "Advanced";
    } else if (filters.skillLevel === '12') {
        skillstr = "Various";
    } else if (filters.skillLevel === '20') {
        skillstr = "Beginner/Intermediate";
    }


    let genderstr = "Gender";
    if (filters.gender === 'm') {
        genderstr = "Male";
    } else if (filters.gender === 'f') {
        genderstr = "Female";
    } else if (filters.gender === 'c') {
        genderstr = "Co-ed";
    } 

    let theid = filters.location || "";
    let facstr ="Location";
    if (theid === "19")     { facstr = "Agriplace"; } 
    else if (theid === "3") { facstr = "Cwench Centre - Etobicoke"; } 
    else if (theid === "12") { facstr = "Jemini"; }
    else if (theid === "18") { facstr = "Lake Barrington"; }
    else if (theid === "2") { facstr = "Langley"; }
    else if (theid === "16") { facstr = "Mississauga"; }
    else if (theid === "8") { facstr = "North Shore"; }
    else if (theid === "13") { facstr = "Oakville"; }
    else if (theid === "14") { facstr = "Oshawa"; }
    else if (theid === "17") { facstr = "Romeoville"; }
    else if (theid === "15") { facstr = "Scarborough"; }
    else if (theid === "1") { facstr = "Scotia Barn"; }
    else if (theid === "10") { facstr = "South Cariboo Rec Centre"; }
    else if (theid === "4") { facstr = "West Dundee"; }
    else if (theid === "11") { facstr = "Winnipeg"; }
    else if (theid === "5") { facstr = "York"; }
    else if (theid === "9") { facstr = "Armstrong"; }
    else if (theid === "21") { facstr = "Libertyville"; }

    let disablegender = "";
    if (filters.type != 'league' && filters.type != 'tournaments' && filters.type != 'camp' && filters.type != 'programs' && filters.type != undefined && filters.type != '') {
        disablegender = "disable";
    }
    // console.log(filters.type);
    // console.log(disablegender);
    let disableskill= "";
    if (filters.type != 'camp' && filters.type != 'programs' && filters.type != 'dropins' && filters.type != undefined && filters.type != '') {
        disableskill = "disable";
    }
    let disablelocation = "";
    // if (['il','bc','on','sk'].includes(window.REGION) === false) {
    //     disablelocation = "disable";
    // }
    let disableage = "";
    if (filters.type === 'camp') {
        disableage = "disable";
    }

    return (
        <div id="activity-finder-filters" className="activity-finder-filters">
            <div className="activity-type-notice">
                <div className="container">
                    <img class="lazy loaded" data-src="/themes/theme/images/icons/magnify.png" alt="Welcome to our Activity Finder" src="/themes/theme/images/icons/magnify.png" data-was-processed="true"></img>
                    <h2>Find Your <br /><span>Activity</span></h2>
                    <p>Start by selecting your <strong>Activity, Activity Type & Age Group</strong>. <br />To narrow down your results, <span class="ul">toggle the filters</span> to find what’s right for you.</p>
                </div>
            </div>
            <form id="activityForm" onSubmit={onSubmit} onReset={onReset}>
                {
                    <div className="activity-details">
                        <div className="container">
                            <div></div>
                            { 
                                <div id="activity-div" className="form-group form-group-select form-group-third">
                                    <p id="activity-title" className="s_title">{currentSport.name || 'Activity'}</p>
                                    
                                    <div id="activity-details" className="details">
                                    <input id="sport" name="sport" type="text" value={ currentSport.slug } />
                                        {sports.map(({sport}) =>{
                                                if (!removeSports.includes(sport.sportid)||filters.type===''){
                                                    return <a 
                                                            onClick={onSportSelect}
                                                            href=""
                                                            data-id={sport.slug}
                                                            data-selectid="sport"
                                                            data-titleid="activity-title"
                                                            data-title={sport.name}
                                                           >
                                                            {sport.name}
                                                           </a>
                                                }
                                            }
                                        )}
                                        <a 
                                            onClick={onSportSelect}
                                            href=""
                                            data-id=""
                                            data-selectid="sport"
                                            data-titleid="activity-title"
                                            data-title="All Activities"
                                        >
                                            All Activities
                                        </a>
                                    </div>
                                </div>
                            }

                            {
                                <div id="activitytype-div" className="form-group form-group-select form-group-third">
                                    <label htmlFor="activity-type">Activity Type</label>
                                    <select defaultValue={filters.type || ''} id="type" name="type" onChange={onTypeSelect} >
                                        <option value="">Activity Type</option>
                                        <option defaultChecked={filters.type === 'programs'} value="programs">Programs</option>
                                        <option defaultChecked={filters.type === 'camp'} value="camp">Camps</option>
                                        <option defaultChecked={filters.type === 'league'} value="league">Leagues</option>
                                        <option defaultChecked={filters.type === 'dropins'} value="dropins">Drop-ins</option>
                                        <option defaultChecked={filters.type === 'tournaments'} value="tournaments">Tournaments</option>
                                        <option value="">All Activity Types</option>
                                    </select>
                                    <p id="activitytype-title" className="s_title">{typestr}</p>
                                    <div id="activitytype-details" className="details">
                                        <a onClick={showSelectOnchange} data-theid="programs" data-theselectid="type" data-thetitleid ="activitytype-title" data-thetitle="Programs" href="">Programs</a>
                                        <a onClick={showSelectOnchange} data-theid="camp" data-theselectid="type" data-thetitleid ="activitytype-title" data-thetitle="Camps" href="">Camps</a>
                                        <a onClick={showSelectOnchange} data-theid="league" data-theselectid="type" data-thetitleid ="activitytype-title" data-thetitle="Leagues" href="" >Leagues</a>
                                        <a onClick={showSelectOnchange} data-theid="dropins" data-theselectid="type" data-thetitleid ="activitytype-title" data-thetitle="Drop-Ins" href="" >Drop-Ins</a>
                                        <a onClick={showSelectOnchange} data-theid="tournaments" data-theselectid="type" data-thetitleid ="activitytype-title" data-thetitle="Tournaments" href="" >Tournaments</a>
                                        <a onClick={showSelectOnchange} data-theid="" data-theselectid="type" data-thetitleid ="activitytype-title" data-thetitle="All Activity Types" href="" >All Activity Types</a>
                                    </div>
                                </div>
                            }

                            <div id="ageRange-div" className={disableage+" form-group form-group-select form-group-third"}>
                                <label htmlFor="age-range">Age Group</label>
                                <select tabIndex="0" defaultValue={filters.ageRange || ''} id="age_range" name="ageRange"  >
                                    <option value="">Age Group</option>
                                    {Object.entries(window.AGE_RANGES[filters.type] || window.AGE_RANGES['tournaments']).map(([id, name]) =>
                                        <option defaultChecked={filters.ageRange === id} value={id}>{name}</option>
                                    )}
                                    <option value="">All Age Groups</option>
                                </select>
                                <p id="ageRange-title" className="s_title">{agestr}</p>
                                <div id="ageRange-details" className="details">
                                    {Object.entries(window.AGE_RANGES[filters.type] || window.AGE_RANGES['tournaments']).map(([id, name]) =>
                                        <a 
                                            onClick={showSelectOnchange} 
                                            data-theid={id} 
                                            data-theselectid="age_range" 
                                            data-thetitleid ="ageRange-title" 
                                            data-thetitle={name} href="" 
                                        >
                                            {name}
                                        </a>
                                    )}
                                    <a onClick={showSelectOnchange} data-theid="" data-theselectid="age_range" data-thetitleid ="ageRange-title" data-thetitle="All Age Groups" href="">All Age Groups</a>
                                </div>
                            </div>

                            <div id="skillLevel-div" className={disableskill+" form-group form-group-select form-group-third"}>
                                    <label htmlFor="skill-level">Skill Level</label>
                                    <select tabIndex="2" defaultValue={filters.skillLevel || ''} id="skill-level" name="skillLevel" >
                                        <option value="">Skill Level</option>
                                        {Object.entries(window.SKILL_LEVELS[filters.type] || window.SKILL_LEVELS['tournaments']).map(([id, name]) =>
                                            <option value={id}>{name}</option>
                                        )}
                                        <option value="">All Skill Levels</option>
                                    </select>
                                    <p id="skillLevel-title" className="s_title">{skillstr}</p>
                                    <div id="skillLevel-details" className="details">
                                        {Object.entries(window.SKILL_LEVELS[filters.type] || window.SKILL_LEVELS['tournaments']).map(([id, name]) =>
                                            <a 
                                                onClick={showSelectOnchange} 
                                                data-theid={id} 
                                                data-theselectid="skill-level" 
                                                data-thetitleid ="skillLevel-title" 
                                                data-thetitle={name} 
                                                href="" 
                                            >
                                                {name}
                                            </a>
                                        )}
                                        <a 
                                            onClick={showSelectOnchange} 
                                            data-theid="" 
                                            data-theselectid="skill-level" 
                                            data-thetitleid ="skillLevel-title" 
                                            data-thetitle="All Skill Levels"
                                            href="" 
                                        >
                                            All Skill Levels
                                        </a>
                                    </div>
                                </div>

                                <div id="gender-div" className={disablegender+" form-group form-group-select form-group-third"}>
                                    <label htmlFor="gender">Gender</label>
                                    <select tabIndex="3" defaultValue={filters.gender || ''} id="gender" name="gender" >
                                        <option value="">Gender</option>
                                        <option value="c">Co-ed</option>
                                        <option value="f">Female</option>
                                        <option value="m">Male</option>
                                        <option value="">All Genders</option>
                                    </select>
                                    <p id="gender-title" className="s_title">{genderstr}</p>
                                    <div id="gender-details" className="details">
                                        <a
                                            onClick={showSelectOnchange} 
                                            data-theid="c" 
                                            data-theselectid="gender" 
                                            data-thetitleid ="gender-title" 
                                            data-thetitle="Co-ed"
                                            href=""

                                        >Co-ed</a>
                                        <a
                                            onClick={showSelectOnchange} 
                                            data-theid="f" 
                                            data-theselectid="gender" 
                                            data-thetitleid ="gender-title" 
                                            data-thetitle="Female"
                                            href=""
                                        >Female</a>
                                        <a
                                            onClick={showSelectOnchange} 
                                            data-theid="m" 
                                            data-theselectid="gender" 
                                            data-thetitleid ="gender-title" 
                                            data-thetitle="Male"
                                            href=""
                                        >Male</a>
                                        <a
                                            onClick={showSelectOnchange} 
                                            data-theid="" 
                                            data-theselectid="gender" 
                                            data-thetitleid ="gender-title" 
                                            data-thetitle="All Genders"
                                            href=""
                                        >All Genders</a>
                                    </div>
                                </div>
                                    
                                <div id="location-div" className={disablelocation+" form-group form-group-select form-group-third"}>
                                    <label htmlFor="location">Location</label>
                                    <select defaultValue={filters.location || ''} id="location" name="location">
                                        <option value="">Location</option>
                                        {Object.entries(facilities[filters.type] || facilities['tournaments']).map(([id, name]) =>
                                            <option value={id}>{name}</option>
                                        )}
                                        <option value="">All Locations</option>
                                    </select>
                                    <p id="location-title" className="s_title">{facstr}</p>
                                    <div id="location-details" className="details">
                                        {Object.entries(facilities[filters.type] || facilities['tournaments']).map(([id, name]) =>
                                            <a
                                                onClick={showSelectOnchange} 
                                                data-theid={id} 
                                                data-theselectid="location" 
                                                data-thetitleid ="location-title" 
                                                data-thetitle={name}
                                                href=""
                                            > 
                                                {name}
                                            </a>
                                        )}
                                            <a
                                                onClick={showSelectOnchange} 
                                                data-theid="" 
                                                data-theselectid="location" 
                                                data-thetitleid ="location-title" 
                                                data-thetitle="All Locations"
                                                href=""
                                            > 
                                                All Locations
                                            </a>
                                    </div>
                                </div>
                            {/* <div id="btndesktop" className="btndesktop">
                                <div id="showmore-div" className="form-group form-group-third">
                                    <p id="showmore" className="s_title">Show More</p>
                                </div>

                                <div className="form-group form-group-third form-group-submit">
                                    <button aria-label="Submit" className="btn btn-slide" type="submit" value="Search">FILTER RESULTS</button>
                                </div> 

                                <button aria-label="Clear" className="strip-style" id="filter-clear">
                                    Clear Results
                                </button>
                            </div> */}

                        </div>
                        <div className="clearcontainer">
                            <button aria-label="Clear" className="strip-style clear_button" id="filter-clear">
                                Reset Filters
                            </button>
                        </div>
{/*   
                        <div id="containerwrapper" class="containerwrapper">
                            <div className="container2">

                                <div id="skillLevel-div" className={disableskill+" form-group form-group-select form-group-third"}>
                                    <label htmlFor="skill-level">Skill Level</label>
                                    <select tabIndex="2" defaultValue={filters.skillLevel || ''} id="skill-level" name="skillLevel" >
                                        <option value="">Skill Level</option>
                                        {Object.entries(window.SKILL_LEVELS[filters.type] || window.SKILL_LEVELS['tournaments']).map(([id, name]) =>
                                            <option value={id}>{name}</option>
                                        )}
                                        <option value="">All Skill Levels</option>
                                    </select>
                                    <p id="skillLevel-title" className="s_title">{skillstr}</p>
                                    <div id="skillLevel-details" className="details">
                                        {Object.entries(window.SKILL_LEVELS[filters.type] || window.SKILL_LEVELS['tournaments']).map(([id, name]) =>
                                            <a 
                                                onClick={showSelectOnchange} 
                                                data-theid={id} 
                                                data-theselectid="skill-level" 
                                                data-thetitleid ="skillLevel-title" 
                                                data-thetitle={name} 
                                                href="" 
                                            >
                                                {name}
                                            </a>
                                        )}
                                        <a 
                                            onClick={showSelectOnchange} 
                                            data-theid="" 
                                            data-theselectid="skill-level" 
                                            data-thetitleid ="skillLevel-title" 
                                            data-thetitle="All Skill Levels"
                                            href="" 
                                        >
                                            All Skill Levels
                                        </a>
                                    </div>
                                </div>

                                <div id="gender-div" className={disablegender+" form-group form-group-select form-group-third"}>
                                    <label htmlFor="gender">Gender</label>
                                    <select tabIndex="3" defaultValue={filters.gender || ''} id="gender" name="gender" >
                                        <option value="">Gender</option>
                                        <option value="c">Co-ed</option>
                                        <option value="f">Female</option>
                                        <option value="m">Male</option>
                                        <option value="">All Genders</option>
                                    </select>
                                    <p id="gender-title" className="s_title">{genderstr}</p>
                                    <div id="gender-details" className="details">
                                        <a
                                            onClick={showSelectOnchange} 
                                            data-theid="c" 
                                            data-theselectid="gender" 
                                            data-thetitleid ="gender-title" 
                                            data-thetitle="Co-ed"
                                            href=""

                                        >Co-ed</a>
                                        <a
                                            onClick={showSelectOnchange} 
                                            data-theid="f" 
                                            data-theselectid="gender" 
                                            data-thetitleid ="gender-title" 
                                            data-thetitle="Female"
                                            href=""
                                        >Female</a>
                                        <a
                                            onClick={showSelectOnchange} 
                                            data-theid="m" 
                                            data-theselectid="gender" 
                                            data-thetitleid ="gender-title" 
                                            data-thetitle="Male"
                                            href=""
                                        >Male</a>
                                        <a
                                            onClick={showSelectOnchange} 
                                            data-theid="" 
                                            data-theselectid="gender" 
                                            data-thetitleid ="gender-title" 
                                            data-thetitle="All Genders"
                                            href=""
                                        >All Genders</a>
                                    </div>
                                </div>
                                    
                                <div id="location-div" className={disablelocation+" form-group form-group-select form-group-third"}>
                                    <label htmlFor="location">Location</label>
                                    <select defaultValue={filters.location || ''} id="location" name="location">
                                        <option value="">Location</option>
                                        {Object.entries(window.FACILITIES[filters.type] || window.FACILITIES['tournaments']).map(([id, name]) =>
                                            <option value={id}>{name}</option>
                                        )}
                                        <option value="">All Locations</option>
                                    </select>
                                    <p id="location-title" className="s_title">{facstr}</p>
                                    <div id="location-details" className="details">
                                        {Object.entries(window.FACILITIES[filters.type] || window.FACILITIES['tournaments']).map(([id, name]) =>
                                            <a
                                                onClick={showSelectOnchange} 
                                                data-theid={id} 
                                                data-theselectid="location" 
                                                data-thetitleid ="location-title" 
                                                data-thetitle={name}
                                                href=""
                                            > 
                                                {name}
                                            </a>
                                        )}
                                            <a
                                                onClick={showSelectOnchange} 
                                                data-theid="" 
                                                data-theselectid="location" 
                                                data-thetitleid ="location-title" 
                                                data-thetitle="All Locations"
                                                href=""
                                            > 
                                                All Locations
                                            </a>
                                    </div>
                                </div>

                                <div id="btnmobile" className="btnmobile">
                                    <div id="showmore-div-m" className="form-group form-group-third">
                                        <p id="showmore-m" className="s_title">Show More</p>
                                    </div>

                                    <div className="form-group form-group-third form-group-submit">
                                        <button aria-label="Submit" className="btn btn-slide" type="submit" value="Search">Search</button>
                                    </div>

                                    <button aria-label="Clear" className="strip-style" id="filter-clear-m">
                                        Clear Results
                                    </button>
                                </div>



                            </div>
                        </div> */}
                    </div>
                }
            </form>
        </div>
    );
};
